export const CLAIMS_MANAGER_CONTRACT_ADDRESS = '0x44617F9dCEd9787C3B06a05B35B4C779a2AA1334';
//# sourceMappingURL=constants.js.map